import { ShareType } from '@utils/pageConfig/Types';
import { SaleType } from '@models/OpportunityReview';
import { SaleType as SaleTypeProducts } from '../models/Products';
import { DEFAULT_VOLUME } from '@utils/factVolumeUtils/FactVolumeUtils';

export enum PerformanceType {
  Volume = 'VOLUME',
  Value = 'VALUE',
}

export enum ShareTypeOptions {
  MARKET_SHARE = 'Market Share',
  RETAILER_MIX = 'Retailer Mix',
  ABSOLUTE = 'Absolute',
  SHARE = 'Share',
}

export const KpiTextForTracking = (volume: string): Record<PerformanceType, string> => ({
  [PerformanceType.Volume]: volume,
  [PerformanceType.Value]: 'Revenue',
});

export const ShareTypeMapping: Record<ShareType, ShareTypeOptions> = {
  [ShareType.MarketShare]: ShareTypeOptions.MARKET_SHARE,
  [ShareType.MyMix]: ShareTypeOptions.RETAILER_MIX,
  [ShareType.Absolute]: ShareTypeOptions.ABSOLUTE,
};

export const SaleTypeMapping = (volume: string = DEFAULT_VOLUME): Record<SaleType, string> => ({
  [SaleType.VALUE]: 'Revenue',
  [SaleType.VOLUME]: volume,
});

export const SaleTypeMappingProducts: Record<SaleTypeProducts, string> = {
  [SaleTypeProducts.volume]: 'Units',
  [SaleTypeProducts.revenue]: 'Revenue',
  [SaleTypeProducts.price]: 'Price',
};

export const FilterLabelTextForTracking = (volume: string): Record<PerformanceType, string> => ({
  [PerformanceType.Volume]: `${volume} Performance`,
  [PerformanceType.Value]: 'Revenue Performance',
});
